export default "__VITE_ASSET__Bs_r2Ckn__"